var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldenTitleBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172.06 12.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 173.36,
    y1: 6.42,
    x2: -26.21,
    y2: 6.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eada92",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#eada92",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#eada92",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#eada92",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#eada92",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#eada92",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#eada92",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#eada92",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eada92",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#eada92",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#eada92"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATER-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "172.06 0 7.73 0 0 12.83 172.06 12.83 172.06 0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenTitleBg);
export default __webpack_public_path__ + "static/media/goldenTitleBg.2dad32e65428779d7dc236c7c04c08a3.svg";
export { ForwardRef as ReactComponent };